<template>

  <div>

      <el-alert v-if="showWarning"
        type="info"
        title="No link to site found, you must select a site below."
        show-icon
        :closable="false">
      </el-alert>

    <component :is="el" :label="label" :required="required">
      <i v-if="noForm && label">{{label}}&nbsp;</i>
      <el-select
      v-model.trim="formData"
      value-key="id"
      :disabled="disabled"
      :placeholder="placeholder"
      filterable
      remote
      :remote-method="findSiteList"
      :loading="loading"
      @change="updated">

      <el-option
        v-for="site in this.sites"
        :key="site.id"
        :label="site.siteName"
        :value="site">
        <span style="float: left">{{ site.siteName }}</span>
        <span style="float: right; color: #8492a6; font-size: 13px">
           <span v-if="site.telcoSiteId" class="text-muted">{{site.telcoSiteId}} |
           </span>{{ site.siteId }}</span>
      </el-option>

      </el-select>

    </component>

    <div v-if="showSite && formData" style="padding-top: 0.5em; padding-bottom: 0.75em;">
      <site-card ref="siteCard" :site-data="formData" :sharer-id="isTelco() ? this.org().id : null" map-right />
    </div>

  </div>

</template>

<script>

import SiteMixins from '@/mixins/SiteMixins'
import SiteCard from '@/components/sites/SiteCard'

export default {
  name: 'select-site',

  mixins: [SiteMixins],

  components: {
    SiteCard
  },

  props: {

    label: {
      type: String,
      default: 'Select Site'
    },

    value: {
//      type: [String, Object, Number],
      required: true
    },

    sharer: {
      type: Number,
      default: null
    },

    provider: {
      type: Number,
      default: null
    },

    showSite: {
      type: Boolean,
      default: true
    },

    actionType: {
      type: String,
      default: null
    },

    excludeSharer: {
      type: Boolean,
      default: false
    },

    backhaulSearch: {
      type: Boolean,
      default: false
    },

    showWarning: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    required: {
      type: Boolean,
      default: false
    },

    fullObject: {
      type: Boolean,
      default: false
    },

    placeholder: {
      type: String,
      default: 'Enter site name or site Id (min 3 letters)'
    },

    helpText: {
      type: String,
      default: null
    },

    callback: {
      type: Function,
      default: null
    },

    noForm: {
      type: Boolean,
      default: true
    }

  },


  methods: {

    updated (site) {
      this.$emit('input', this.fullObject ? site : site.id)
      this.$emit('change', this.fullObject ? site : site.id)

      if (this.callback) {
        this.callback(site.id, site.siteName, site)
      }

      if (this.fullObject) {
        this.formData = site
      }

      this.$nextTick(() => {
        if (site) {
           this.$refs.siteCard.setSiteData(site)
        }
      })

    },

    findSiteList (value) {
      if (value) {

        if (this.backhaulSearch) {
          this.filterBackhaulSites(value,
            this.findCallback,
            this.isTelco() ? this.org().id : this.sharer, this.provider)
        } else {
          this.filterSites(value, this.findCallback, this.sharer, this.excludeSharer, this.actionType)
        }

      }
    },

    findCallback (response) {
      this.sites = response
    }

  },



  data () {

    return {
      formData: this.value,
      loading: false,
      sites: [],
      el: this.noForm ? 'div' : 'el-form-item'
    }
  }, // data

}
</script>

<stype scoped>
  .el-select {
    display: inline-block;
    width: 100%;
  }
</style>
